module.exports = __webpack_public_path__ + "img/bg6-mobile.b344f638.jpg";